import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=1cb5d44e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb5d44e')) {
      api.createRecord('1cb5d44e', component.options)
    } else {
      api.reload('1cb5d44e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=1cb5d44e&", function () {
      api.rerender('1cb5d44e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25hHyzRE479gO/JS/imageCarousel.vue"
export default component.exports